import React from 'react';
import { useMutation } from '@apollo/client';
import { AppContext, EventEmitter, toast } from '@nile/components';
import {
  GET_ALL_APPROVAL_STATUS,
  IS_APPROVAL_PENDING,
  UPDATE_APPROVAL,
  useCachedQuery,
  useNoCacheQuery
} from '@nile/graphql';
import {
  Button,
  ButtonGroup,
  Card,
  TextField
} from '@superops/ui-design-system';
import { useContext, useState } from 'react';
import { FormattedMessage } from 'react-intl';

function ApprovalWidget(props) {
  const { ticket } = props;
  const appContext = useContext(AppContext);
  const [comments, setComments] = useState('');
  const [updateLoading, setLoading] = useState(false);
  const [showWidget, setShowWidget] = useState(true);
  const { loading, error, data } = useNoCacheQuery(IS_APPROVAL_PENDING, {
    variables: {
      ticketId: ticket.ticketId
    }
  });
  const {
    data: approvalStatuses,
    loading: statusLoading,
    error: statusError
  } = useCachedQuery(GET_ALL_APPROVAL_STATUS);
  const [updateApproval] = useMutation(UPDATE_APPROVAL, {
    onCompleted({ updateApproval }) {
      toast('success', 'Approval status updated successfully');
      EventEmitter.dispatch('approvalChange');
      setLoading(false);
      setShowWidget(false);
    },
    onError() {
      setLoading(false);
      toast('error', 'Error occured');
    }
  });
  if (appContext.accountType !== 'CLIENT') return '';
  if (loading) return '';
  if (error || statusError) return <div>error...</div>;
  const approveTicket = () => {
    const approvalStatus = approvalStatuses.getAllApprovalStatus.find(
      (el) => el.state === 'APPROVE'
    )?.name;
    setLoading(true);
    updateApproval({
      variables: {
        approvalId: data?.isLoggedInUserHasPendingApproval,
        approvalInput: {
          status: approvalStatus,
          comment: comments
        }
      }
    });
  };
  const rejectTicket = () => {
    const approvalStatus = approvalStatuses.getAllApprovalStatus.find(
      (el) => el.state === 'REJECT'
    )?.name;
    setLoading(true);
    updateApproval({
      variables: {
        approvalId: data?.isLoggedInUserHasPendingApproval,
        approvalInput: {
          status: approvalStatus,
          comment: comments
        }
      }
    });
  };
  const askMoreInfo = () => {
    const approvalStatus = approvalStatuses.getAllApprovalStatus.find(
      (el) => el.state === 'NEED_MORE_INFORMATION'
    )?.name;
    setLoading(true);
    updateApproval({
      variables: {
        approvalId: data?.isLoggedInUserHasPendingApproval,
        approvalInput: {
          status: approvalStatus,
          comment: comments
        }
      }
    });
  };
  if (data?.isLoggedInUserHasPendingApproval && showWidget) {
    return (
      <div className="p15">
        <Card>
          <div className="p15">
            <div>
              <FormattedMessage id="entity.approval" />
            </div>
            <div className="mt15">
              <TextField
                value={comments}
                multiline
                name="comments"
                onChange={(val) => {
                  setComments(val);
                }}
                placeholder="Approval comments"
                type="text"
              />
            </div>
            <div>
              <div className="flex jend mt10">
                <ButtonGroup>
                  <Button onClick={askMoreInfo} disabled={updateLoading}>
                    <FormattedMessage id="ticket.details.runbook.needMoreInfo" />
                  </Button>
                  <Button onClick={rejectTicket} disabled={updateLoading}>
                    <FormattedMessage id="ticket.approvalTemplate.reject" />
                  </Button>
                  <Button
                    onClick={approveTicket}
                    primary
                    disabled={updateLoading}
                  >
                    <FormattedMessage id="common.approve" />
                  </Button>
                </ButtonGroup>
              </div>
            </div>
          </div>
        </Card>
      </div>
    );
  }
  return '';
}

export default ApprovalWidget;
